// extracted by mini-css-extract-plugin
export default {"overlay":"Jy-z","bodyOpen":"Ky-z","content":"Ly-z","header":"My-z","close":"Ny-z","closeNoHeading":"Oy-z"};